/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TechStorageUsbIcon16Light = forwardRef('TechStorageUsbIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "m12.774 7.117.176.176a1 1 0 0 1 0 1.414L8 13.657A4 4 0 1 1 2.343 8l4.95-4.95a1 1 0 0 1 1.414 0l.175.175 2.122-2.12a1 1 0 0 1 1.414 0l2.478 2.477a1 1 0 0 1 0 1.414l-2.122 2.121ZM9.59 3.933l2.478 2.477 2.121-2.12-2.477-2.479-2.122 2.122ZM3.05 12.95a3 3 0 0 1 0-4.243L8 3.757 12.243 8l-4.95 4.95a3 3 0 0 1-4.243 0Z" })));
});
